import React from 'react'
import { css } from 'aphrodite'
import { Row, Col } from 'reactstrap'

import style from './style'

import ScrollArea from '../../../partials/ScrollArea'

export const RevenueTable = props => {
  const _report = [
    ...props.revenue.map(r => ({ ...r, _dType: 'revenue' })),
    ...props.transactions.map(t => ({ ...t, _dType: 'transactions' })),
    ...props.stats.map(r => ({ ...r, _dType: 'stats' }))
  ]
    .reduce((arr, item) => {
      const _iDateStr = item.date.split('-')
      _iDateStr[1] = +_iDateStr[1] - 1

      const _iDate = new Date(..._iDateStr)
      const currItemIndex = arr.findIndex(_item => {
        const __iDateStr = _item.date.split('-')
        __iDateStr[1] = +__iDateStr[1] - 1
        const __iDate = new Date(...__iDateStr)

        if (item._dType === 'revenue') {
          return (
            _iDate.getUTCMonth() === __iDate.getUTCMonth() &&
            _iDate.getUTCFullYear() === __iDate.getUTCFullYear()
          )
        } else {
          return (
            _iDate.getUTCDate() === __iDate.getUTCDate() &&
            _iDate.getUTCMonth() === __iDate.getUTCMonth() &&
            _iDate.getUTCFullYear() === __iDate.getUTCFullYear()
          )
        }
      })

      return [
        ...(currItemIndex > -1
          ? [
            ...arr.slice(0, currItemIndex),
            {
              ...(item._dType === 'transactions'
                  ? {
                    ...arr[currItemIndex],
                    transactions: [
                      ...(arr[currItemIndex].transactions || []),
                      item
                    ]
                  }
                  : item._dType === 'revenue'
                    ? {
                      ...arr[currItemIndex],
                      revenue: [
                        ...(arr[currItemIndex].revenue || []),
                        ...item.report.filter(
                            __item => __item.date === item.date
                          )
                      ]
                    }
                    : {
                      ...arr[currItemIndex],
                      ...item
                    })
            },
            ...arr.slice(currItemIndex + 1)
          ]
          : (function () {
            if (item._dType === 'revenue') {
              const groupReportItems = item.report.reduce((_obj, __item) => {
                return {
                  ..._obj,
                  [__item.date]: [...(_obj[__item.date] || []), __item]
                }
              }, {})

              return [
                ...arr,
                ...Object.keys(groupReportItems).reduce(
                    (_arr, __item) => [
                      ..._arr,
                      {
                        test: true,
                        date: __item,
                        revenue: groupReportItems[__item],
                        transactions: []
                      }
                    ],
                    []
                  )
              ]
            } else if (item._dType === 'transactions') {
              return [
                ...arr,
                {
                  date: item.date,
                  transactions: [item],
                  revenue: []
                }
              ]
            } else {
              return [
                ...arr,
                {
                  ...item,
                  transactions: [],
                  revenue: []
                }
              ]
            }
          })())
      ]
    }, [])
    .sort(
      (a, b) =>
        new Date(Date.UTC(...a.date.split('-'))).getTime() -
        new Date(Date.UTC(...b.date.split('-'))).getTime()
    )

  return [
    <Col key={0} />,
    <ScrollArea
      key={1}
      style={{
        height: `300px`
      }}
    >
      <Col>
        <HeaderRow theme={props.theme} />
        {_report.map((item, index) => (
          <RevenueRow
            theme={props.theme}
            key={`${index}_${item.id}`}
            report={item}
            onClick={props.onItemClick}
            active={props.active}
          />
        ))}
      </Col>
    </ScrollArea>
  ]
}

export const HeaderRow = props => {
  return (
    <Row
      className={css(
        style.list.header,
        style[props.theme.name] ? style[props.theme.name].list.header : null
      )}
    >
      <Col>
        <Row>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter
              )}
            >
              date
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter
              )}
            >
              queries
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter
              )}
            >
              impressions
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter
              )}
            >
              clicks
            </span>
          </Col>
          <Col>
            <span
              className={css(
                style.item.span,
                style.item.headerSpan,
                style.item.spanCenter
              )}
            >
              amount
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export const RevenueRow = props => {
  const dateArr = props.report.date.split('-')
  const transactionAmount = props.report.transactions.reduce(
    (n, t) => n + +t.amount,
    0
  )
  const revenueAmount = props.report.revenue.reduce((n, t) => n + +t.amount, 0)
  const totalRevenue = +revenueAmount - transactionAmount

  return (
    <Row
      data-id={props.report.id}
      onClick={props.onClick}
      className={css(
        style.list.row,
        style[props.theme.name] ? style[props.theme.name].list.row : null,
        props.active.id === props.report.id + ''
          ? style[props.theme.name]
            ? (style.list.activeRow, style[props.theme.name].list.activeRow)
            : style.list.activeRow
          : null
      )}
    >
      <Col>
        <Row>
          <Col>
            <span className={css(style.item.span, style.item.spanCenter)}>
              {`${dateArr[1]}/${dateArr[2]}/${dateArr[0]}`}
            </span>
          </Col>
          <Col>
            <span className={css(style.item.span, style.item.spanCenter)}>
              {props.report.queries || '--'}
            </span>
          </Col>
          <Col>
            <span className={css(style.item.span, style.item.spanCenter)}>
              {props.report.impressions || '--'}
            </span>
          </Col>
          <Col>
            <span className={css(style.item.span, style.item.spanCenter)}>
              {props.report.clicks || '--'}
            </span>
          </Col>
          <Col>
            <span className={css(style.item.span, style.item.spanCenter)}>
              {totalRevenue >= 0
                ? `$${totalRevenue.toFixed(2)}`
                : `-$${Math.abs(totalRevenue).toFixed(2)}`}
            </span>
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default RevenueTable



// WEBPACK FOOTER //
// ./src/components/Community/partials/RevenueTable/index.js